import { ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';

// -- ConversationReplyBubble ---------------------------------------------------
// The student/learner reply bubble, shared between the student runtime and the
// admin Flow Editor preview so the preview matches what students see. A display
// element with no action, so it renders as a box rather than a button (which a
// screen reader would announce, and which would take keyboard focus, for nothing).
export function ConversationReplyBubble({
  children,
  isRtl = false,
}: {
  children: ReactNode;
  isRtl?: boolean;
}) {
  return (
    <Flex justifyContent="flex-end" width="100%" dir={isRtl ? 'rtl' : undefined}>
      <Flex
        contentEditable={false}
        borderTopLeftRadius="2xl"
        borderTopRightRadius="2xl"
        borderBottomRightRadius={isRtl ? '2xl' : '0'}
        borderBottomLeftRadius={isRtl ? '0' : '2xl'}
        alignSelf="flex-end"
        minH={9}
        py={1}
        px={3}
        maxW={{ base: '75%', md: '70%' }}
        align="center"
        textAlign={isRtl ? 'right' : 'left'}
        whiteSpace="normal"
        wordBreak="break-word"
        my={1}
        // The brand-purple background the bubble had as a Button (pro-theme's
        // default primary/brand variant), with white text for contrast.
        bg="accent"
        color="white"
        fontSize="md"
      >
        {children}
      </Flex>
    </Flex>
  );
}
